(function () {

    'use strict';

    var $ = require('jquery');

    function recalculateFooter () {

        var $block  = $('.contact-form');

        if ($block.length > 0) {

            var formH = $block.height();

            var $person     = $block.closest('.contact-form-wrapper').find('.person');
            var personWidth = $person.width();

            //  Make height equal to width
            $person.height(personWidth);

            var $details = $('.details');

            //  Set detail block height
            $details.height(formH - personWidth);

        }
    }

    function customFormElements() {

        var toggle_label = function () {
            $labels.removeClass('selected');
            $labels.filter(':has(:checked)').addClass('selected');
        };
        var $labels = $('.checkbox, .radio').closest('label').click(toggle_label);
        toggle_label();

    }

    function renderForm() {

        //  GravityForms - custom checkboxes and radio's
        var $choiceBoxes = $('.gfield_radio li, .gfield_checkbox li');

        if ($choiceBoxes.length > 0) {

            $choiceBoxes.each(function () {

                var $this = $(this);
                var oldInput = $this.find('input');
                var className = $this.parent().attr('class').replace('gfield_', '');

                $this
                    .find('label')
                    .addClass(className)
                    .prepend(oldInput);
            });

            customFormElements();

        }

        //  GravityForms - Submitbutton replace
        var $gravityForm = $('.gform_wrapper');

        //  Replace the submit input for a descent button
        var $gSubmitButton = $gravityForm.find('input[type="submit"]');
        var $formButton = $('<button></button>');

        $gSubmitButton.each(function() {
            $.each(this.attributes, function() {
                if(this.specified) {

                    if (this.name === 'class') {
                        this.value = this.value + ' primary';
                    }

                    if (this.name === 'value') {
                        $formButton.html('<span class="line">'+this.value+'</span>');
                    } else {
                        $formButton.attr(this.name, this.value);
                    }

                }
            });
        });

        $gravityForm.find('.gform_footer').prepend($formButton);
        $gSubmitButton.remove();

        //  Recalculate
        $(window).trigger('resize');

    }

    customFormElements();

    //  GravityForms Ajax hook
    $(document).bind('gform_post_render', function(ev) {
        renderForm();
    });

    $(window).on('load resize touchmove', function () {
        if ($(window).width() >= 1024) {
            recalculateFooter();
        }
    });

})();